import { render, staticRenderFns } from "./rds-table.vue?vue&type=template&id=79b60470&scoped=true&"
import script from "./rds-table.vue?vue&type=script&lang=js&"
export * from "./rds-table.vue?vue&type=script&lang=js&"
import style0 from "./rds-table.vue?vue&type=style&index=0&id=79b60470&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b60470",
  null
  
)

export default component.exports